import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ContentTap icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ContentTap } from '@sravni/design-system-icons'
 *
 * <ContentTap />
 * ```
 */
var ContentTap = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ContentTap", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.462 13.255c-.067-.067-.185-.067-.269 0-.42.404-1.75 1.75-1.75 2.877 0 1.346.976 1.868 1.885 1.868.908 0 1.884-.522 1.884-1.868 0-1.144-1.312-2.473-1.75-2.877ZM17.92 6.647h-2.34c-.37-.555-.941-1.703-1.598-1.888v-.417h.976c.438 0 .808-1.097.808-1.534A.819.819 0 0 0 14.958 2h-3.567a.819.819 0 0 0-.807.808c0 .437.37 1.534.807 1.534h.976v.417c-.656.185-1.228 1.333-1.598 1.888h-.471c-2.81 0-5.132 1.36-5.518 4.051h-.59a.452.452 0 0 0-.454.454v.724c0 .252.202.454.455.454h4.29a.452.452 0 0 0 .454-.454v-.724a.452.452 0 0 0-.454-.454h-.387a2.317 2.317 0 0 1 2.153-1.531h.505a2.904 2.904 0 0 0 4.812 0h2.338a.452.452 0 0 0 .455-.454V7.1a.428.428 0 0 0-.438-.454Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { ContentTap };
//# sourceMappingURL=ContentTap.js.map
